import { FormControl, InputLabel, TextField, Box, Typography } from "@mui/material";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";

const InputBox = ({ name, value, onChange, onKeyUp, onBlur, parent }) => (
  <TextField
    id={parent + name}
    name={name}
    value={value}
    onChange={onChange}
    onKeyUp={onKeyUp}
    onBlur={onBlur}
    type="number"
    inputProps={{ maxLength: 3 }}
    sx={{
      width: "40px !important",
      "& .MuiInputBase-root": {
        border: "unset",
        "& input": {
          padding: "0 4px",
        },
      },
    }}
  />
);

const Dot = () => (
  <Box mx={1}>
    <Typography>.</Typography>
  </Box>
);

const IpInput = ({ label, name, value, onChange, disabled }) => {
  const [formData, setFormData] = useState({
    ip1: "",
    ip2: "",
    ip3: "",
    ip4: "",
  });

  useEffect(() => {
    if (Object.values(formData).every((it) => it)) {
      onChange({
        target: {
          name,
          value: Object.values(formData).join("."),
        },
      });
    }
  }, [formData]);

  useEffect(() => {
    const tokens = value.split(".");
    if (tokens) {
      let obj = {
        ip1: "",
        ip2: "",
        ip3: "",
        ip4: "",
      };
      tokens.forEach((it, i) => {
        const key = `ip${i + 1}`;
        obj = {
          ...obj,
          [key]: it,
        };
      });

      setFormData({ ...formData, ...obj });
    }
  }, [value]);

  const onChangeInput = (e) => {
    if (e.target.value.length <= 3) {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    } else {
      const newValue = e.target.value.slice(-1);
      const nextName = Number(e.target.name.slice(-1)) + 1;
      if (nextName <= 4) {
        const key = `ip${nextName}`;
        document.getElementById(name + key).focus();
        setFormData({ ...formData, [key]: newValue });
      }
    }
  };

  const onKeyUp = (e) => {
    if (e.keyCode === 8 && isEmpty(e.target.value)) {
      const prev = Number(e.target.name.slice(-1)) - 1;
      if (prev > 0) {
        const key = `ip${prev}`;
        document.getElementById(name + key).focus();
      }
    }
  };

  const onBlur = () => {
    if (Object.values(formData).every((it) => isEmpty(it))) {
      onChange({
        target: {
          name,
          value: "",
        },
      });
    }
  };

  return (
    <FormControl disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          borderBottom: "2px solid #004057",
          px: 1,
          height: "48px",
          width: "224px",
        }}
      >
        <InputBox
          name="ip1"
          value={formData.ip1}
          onChange={onChangeInput}
          onKeyUp={onKeyUp}
          onBlur={onBlur}
          parent={name}
        />
        <Dot />
        <InputBox
          name="ip2"
          value={formData.ip2}
          onChange={onChangeInput}
          onKeyUp={onKeyUp}
          onBlur={onBlur}
          parent={name}
        />
        <Dot />
        <InputBox
          name="ip3"
          value={formData.ip3}
          onChange={onChangeInput}
          onKeyUp={onKeyUp}
          onBlur={onBlur}
          parent={name}
        />
        <Dot />
        <InputBox
          name="ip4"
          value={formData.ip4}
          onChange={onChangeInput}
          onKeyUp={onKeyUp}
          onBlur={onBlur}
          parent={name}
        />
      </Box>
    </FormControl>
  );
};

export default IpInput;
